import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getAgreement=()=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_AGREEMENT_START
    })
    await axios.get('/agreements')
            .then(response=>dispatch({
                type:actionTypes.GET_AGREEMENT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_AGREEMENT_FAIL,
                payload:getMessage(error)
            }))
}